import React, { createContext, useCallback, useContext, useState } from 'react';

type MobileNavContextValue = {
  mobileNavOpen: boolean;
  openMobileNav: () => void;
  closeMobileNav: () => void;
  toggleMobileNav: () => void;
};

const MobileNavContext = createContext<MobileNavContextValue>({
  mobileNavOpen: false,
  openMobileNav: () => {},
  closeMobileNav: () => {},
  toggleMobileNav: () => {},
});

interface MobileNavProviderProps {
  children: React.ReactNode;
}

export const MobileNavProvider: React.FC<MobileNavProviderProps> = ({ children }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const openMobileNav = useCallback(() => setMobileNavOpen(true), []);
  const closeMobileNav = useCallback(() => setMobileNavOpen(false), []);
  const toggleMobileNav = useCallback(() => setMobileNavOpen((prev) => !prev), []);

  return (
    <MobileNavContext.Provider
      value={{ mobileNavOpen, openMobileNav, closeMobileNav, toggleMobileNav }}
    >
      {children}
    </MobileNavContext.Provider>
  );
};

export const useMobileNav = (): MobileNavContextValue => useContext(MobileNavContext);
